import { put, takeLatest, call, all } from 'redux-saga/effects';
import axios from 'axios';
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  CUSTOMER_PRIORITY_LIST_REQUEST,
  CUSTOMER_PRIORITY_LIST_SUCCESS,
  CUSTOMER_PRIORITY_LIST_FAILED,
  CUSTOMER_PRIORITY_IMPORT_REQUEST,
  CUSTOMER_PRIORITY_IMPORT_SUCCESS,
  CUSTOMER_PRIORITY_IMPORT_FAILED,
  CUSTOMER_PRIORITY_REMOVE_REQUEST,
  CUSTOMER_PRIORITY_REMOVE_SUCCESS,
  CUSTOMER_PRIORITY_REMOVE_FAILED,
} from "../../../_utils/constants/CustomerPriority";

function* fetchCustomerPriorityList(action) {
  try {
    const response = yield call(axios.get, `${API_URL}/User/api/CustomerPriority/GetList?storeId=${action.storeId}`, { headers: { Authorization: `Bearer ${action.token}` } });
    yield put({ type: CUSTOMER_PRIORITY_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: CUSTOMER_PRIORITY_LIST_FAILED, payload: error.response });
    }
  }
}

function* customerPriorityImportRequest(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/User/api/CustomerPriority/Import`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: CUSTOMER_PRIORITY_IMPORT_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: CUSTOMER_PRIORITY_IMPORT_FAILED,
        payload: error.response
      });
    }
  }
}

function* customerPriorityRemoveRequest(action) {
  try {
    const response = yield call(
      axios.delete,
      `${API_URL}/User/api/CustomerPriority/Remove?storeId=${encodeURIComponent(action.payload.storeId)}`, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      }
    },
    );
    yield put({
      type: CUSTOMER_PRIORITY_REMOVE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: CUSTOMER_PRIORITY_REMOVE_FAILED,
        payload: error.response
      });
    }
  }
}

export default function* rootCustomerPriority() {
  yield all([
    takeLatest(CUSTOMER_PRIORITY_LIST_REQUEST, fetchCustomerPriorityList),
    takeLatest(CUSTOMER_PRIORITY_IMPORT_REQUEST, customerPriorityImportRequest),
    takeLatest(CUSTOMER_PRIORITY_REMOVE_REQUEST, customerPriorityRemoveRequest),
  ])
}
